import React from "react";
import { useSelector } from "react-redux";

import { useDialogState } from "../../../../../hooks/useDialogState";
import { useTreeState } from "../../../../../hooks/useTreeState";
import { useComponentState } from "../../../../../hooks/useComponentState";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Alert from "@mui/material/Alert";
import TreeComponentTypeService from "../../../../../services/TreeComponentTypeService";
import {trackPromise} from "react-promise-tracker";
import LoadingIndicator from "../../../../../shared/LoadingIndicator";

import {useStylesDialog} from "../../../../../shared/useStyleDialog";

// Fenster zum Löschen des ausgewählten Bauteils

// Transition legt fest, wie das Fenster erscheint
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

export default function DeleteCompDialog() {
    const classesDialog = useStylesDialog();
    const dialog = useDialogState();
    const tree = useTreeState();
    const component = useComponentState();
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const DeleteCompDialogOpen = dialog.deleteCompOpen;
    const setDeleteCompDialogOpen = dialog.setDeleteCompOpen;
    const TreeSelected = tree.selected;

    const Comp_Delete = async () => {
        try {
            await trackPromise((async () => {
                await TreeComponentTypeService.deleteComponentType(token, realm, TreeSelected.global_id);
                const result = await TreeComponentTypeService.getTreeData(token, realm);
                tree.setItems(result.data);
                component.setIsSelected(false);
            })());
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <div>
            <LoadingIndicator/>
            <Dialog
                className={classesDialog.dialog50}
                open={DeleteCompDialogOpen}
                onClose={() => setDeleteCompDialogOpen(false)}
                TransitionComponent={Transition}
            >
                <AppBar className={classesDialog.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setDeleteCompDialogOpen(false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classesDialog.title}>
                            Bauteil <b>{TreeSelected.name}</b> löschen
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <Alert variant="outlined" severity="error">
                        <b>Möchten Sie das Bauteil{" "}
                            <div className={classesDialog.highlight}>{TreeSelected.name}</div>{" "}
                            wirklich löschen?</b>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setDeleteCompDialogOpen(false);
                        }}
                        color="primary"
                    >
                        Abbrechen
                    </Button>
                    <Button
                        onClick={async () => {
                            await Comp_Delete();
                            setDeleteCompDialogOpen(false);
                        }}
                        color="primary"
                    >
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
